/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_My_DecksInputs */



/**
* | output |
* | --- |
* | "Your Decks" |
*
* @param {Decks_My_DecksInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_my_decks = /** @type {((inputs?: Decks_My_DecksInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_My_DecksInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos Decks")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sus Decks")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seus Decks")
	if (locale === "it") return /** @type {LocalizedString} */ ("I tuoi Deck")
	return /** @type {LocalizedString} */ ("Your Decks")
});